
import { PAGES } from "@consts";

export default {
	name: "HintsSection",
	props: {
		hints: {
			type: Array,
			required: true,
		},
		dateCode: {
			type: String,
			required: true,
			validator(val) {
				return /^\d{6}$/.test(val);
			},
		},
	},
	data() {
		return {
			localHints: [],
		};
	},
	computed: {
		localStorageKey() {
			return this.$route.name === PAGES.WORDLE_YESTERDAY_HINTS
				? "WFW_WORDLE_YESTERDAY_HINTS"
				: "WFW_WORDLE_HINTS";
		},
	},
	created() {
		this.localHints = this.hints.map((hint, index) => ({
			hintText: hint,
			showHint: false,
			disabled: index !== 0,
			buttonText: this.getButtonText(index),
		}));
	},
	mounted() {
		this.loadState();
	},
	methods: {
		onButtonClick(index) {
			this.localHints[index].showHint = true;

			if (index + 1 < this.localHints.length) {
				this.localHints[index + 1].disabled = false;
			}

			this.$store.dispatch("tracking/trackEvent", {
				eventCategory: "Wordle Hints",
				eventAction: `Show hint ${index + 1}`,
			});

			this.saveState();
		},
		getButtonText(index) {
			let numberAsWord;
			switch (index) {
				case 0:
					numberAsWord = "One";
					break;
				case 1:
					numberAsWord = "Two";
					break;
				case 2:
					numberAsWord = "Three";
			}

			return numberAsWord
				? `Wordle Hint ${numberAsWord}`
				: `Show me the hint`;
		},
		saveState() {
			if (process.server) {
				return;
			}

			const key = this.localStorageKey;

			const states = this.localHints
				.map((hint) => (hint.showHint ? "1" : "0"))
				.join("");

			const saveString = `${this.dateCode}_${states}`;
			window.localStorage.setItem(key, saveString);
		},
		loadState() {
			if (process.server) {
				return;
			}

			const key = this.localStorageKey;

			const data = window.localStorage.getItem(key);
			if (!data) {
				return;
			}

			const regex = /^(\d{6})_([01]+)$/;
			if (!regex.test(data)) {
				window.localStorage.removeItem(key);
				return;
			}

			const [, dateCode, states] = data.match(regex);
			if (dateCode !== this.dateCode) {
				window.localStorage.removeItem(key);
				return;
			}

			if (states.length !== this.hints.length) {
				window.localStorage.removeItem(key);
				return;
			}

			states.split("").forEach((state, i) => {
				if (state === "1") {
					this.localHints[i].showHint = true;
					this.localHints[i].disabled = false;

					if (i + 1 < this.localHints.length) {
						this.localHints[i + 1].disabled = false;
					}
				}
			});
		},
	},
};
